"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProductsByIdsEndpointRequest = void 0;
const ProductWith_1 = require("../../types/ProductWith");
function createProductsByIdsEndpointRequest(parameters) {
    if (parameters.productIds.length === 0) {
        throw new Error(`"productIds" parameter must not be an empty array.`);
    }
    return {
        method: 'GET',
        endpoint: `products`,
        params: Object.assign(Object.assign(Object.assign(Object.assign({ ids: parameters.productIds.join(`,`) }, (parameters.with
            ? { with: (0, ProductWith_1.productWithQueryParameterValues)(parameters.with).join(`,`) }
            : undefined)), (parameters.campaignKey
            ? { campaignKey: parameters.campaignKey }
            : undefined)), (parameters.pricePromotionKey
            ? {
                pricePromotionKey: parameters.pricePromotionKey,
            }
            : undefined)), (parameters.includeSellableForFree
            ? { includeSellableForFree: parameters.includeSellableForFree }
            : undefined)),
    };
}
exports.createProductsByIdsEndpointRequest = createProductsByIdsEndpointRequest;
